<td class="save-view__table__cell">
  @if (isLoading()) {
    <p-skeleton width="2rem" height="1rem"></p-skeleton>
  }

  @if (isSuccess()) {
    <span class="save-view__table__cell__hit">
      {{ filterHits() | localizedNumber }}
    </span>
  }

  @if (isOnError()) {
    <em class="pi pi-exclamation-triangle save-view__table__cell__loading--failed"></em>
  }
</td>
<td class="save-view__table__cell">{{ savedView().name }}</td>
<td class="save-view__table__cell">
  <p-button
    icon="pi pi-external-link"
    (onClick)="goToSavedView(savedView())"
    [rounded]="true"
    styleClass="save-view__table__cell__goto"
    variant="text"
  />
</td>
